import { store } from "./store";
import { refreshMeters, refreshUser } from "./user";

/**
 * 通过刷新用户信息来判断是否已登陆
 * @returns {Promise<boolean>} 登陆返回 true, 否则返回 false
 */
export const isAuthenticated = async () => {
  try {
    // NOTE: 需要 unwrap 否则不会抛出异常.
    await store.dispatch(refreshUser()).unwrap();
    return true;
  } catch (err) {
    return false;
  }
};

/**
 * 刷新所有 redux 数据
 * @returns {Promise<void>}
 */
export const refreshRedux = async () => {
  try {
    // 减少未登陆时的无意义后端调用操作
    if (!await isAuthenticated()) return;

    await store.dispatch(refreshMeters()).unwrap();
  } catch (err) {
    console.error(err);
  }
};
